import ImageText from "../common/ImageText";
import Counter from "../common/Counter";
import TechSpecs from "../common/TechSpecs";
import "../global.css";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import OverlayForm from "../components/OverlayForm";
import CustomizePavel from "../common/CustomizePavel";
import PavelPowerTable from "../common/PavelPowerTable";
import { Helmet } from "react-helmet-async";
import ImageTextWithStatus from "../common/ImageTextWithStatus";

/* Come <Counter type="custom" />, ma con tipografia responsive.
   Serve perché il text-4xl fisso di Counter faceva sbordare "ELECTRICAL"
   (parola senza spazi, quindi non può andare a capo) di 27px a 768px.
   Tenuto locale per non alterare SARA / HOLLY / MARA, che usano Counter
   con stringhe diverse. Il Counter del lead time qui sotto resta invariato:
   è numerico e gli serve l'animazione CountUp. */
const PavelStat: React.FC<{ upper: string; value: string; label: string }> = ({
  upper,
  value,
  label,
}) => (
    <div className="text-center p-4 min-w-0">
      <div className="pb-3 md:pb-4 leading-snug text-base md:text-sm lg:text-base xl:text-lg">
        {upper}
      </div>
      <div className="font-bold uppercase leading-tight tracking-tight break-words text-3xl md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl">
        {value}
      </div>
      <div className="uppercase pt-3 md:pt-4 leading-snug break-words text-lg md:text-sm lg:text-base xl:text-lg 2xl:text-xl">
        {label}
      </div>
    </div>
);

export default function Product_PAVEL() {
  useEffect(() => {
    if (window.location.hash) {
      let newPath = window.location.pathname + window.location.search;
      if (newPath.endsWith("/")) {
        newPath = newPath.slice(0, -1);
      }
      window.history.pushState("", document.title, newPath);
    }
  }, []);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleRequestClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
      <div>
        <Helmet>
          <title>PAVEL | Revolv Space</title>
          <meta
              name="description"
              content="PAVEL is a deployable solar array for CubeSats, available in 6U, 8U, 12U and 16U sizes with flight-proven deployment system."
          />
        </Helmet>

        {/* IMMAGINE PRODOTTO — solo DESKTOP.
            Prima la larghezza derivava da padding fissi in rem (w-full + px-[20rem]…),
            quindi valeva "viewport meno un valore fisso": 116px su iPad e 2932px su 4K.
            Ora è dimensionata in vw con minimo e massimo. */}
        <div className="hidden md:flex absolute left-0 right-0 mt-[1rem] justify-center pointer-events-none">
          <img
              src="/products/Pavel/PAVEL 4.png"
              alt="PAVEL Solar Array"
              className="w-[44vw] min-w-[360px] max-w-[700px] h-auto object-contain opacity-100 bg-transparent"
              data-aos="fade-zoom-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              data-aos-once="true"
          />
        </div>

        <div className="relative flex flex-col h-full mt-8 md:mt-20">
          {/* ── TITLE SECTION ── 1 colonna su mobile, 2 su desktop */}
          <div className="grid grid-cols-1 md:grid-cols-2 z-40 mb-4">
            <div>
              <h1 className="opacity-0 animate-fadeIn delay-0 md:w-4/6 mx-12 mt-24 md:mt-24 2xl:text-7xl xl:text-7xl lg:text-7xl text-4xl leading-120 tracking-tighter text-left uppercase font-bold text-white dark:text-white">
                PAVEL
              </h1>

              {/* IMMAGINE PRODOTTO — solo MOBILE (in-flow, impilata) */}
              <img
                  src="/products/Pavel/PAVEL 4.png"
                  alt="PAVEL Solar Array"
                  className="block md:hidden w-[70vw] max-w-[360px] h-auto mx-auto my-4 opacity-100"
                  data-aos="fade-zoom-in"
                  data-aos-offset="200"
                  data-aos-easing="ease-in-sine"
                  data-aos-duration="600"
                  data-aos-once="true"
              />

              <div className="opacity-0 animate-fadeIn delay-1 mx-12 uppercase 2xl:text-2xl xl:text-2xl lg:text-2xl pt-8 md:pt-20 text-1xl text-white leading-34 tracking-tight text-left max-w-full md:max-w-1/2">
                HIGH-RELIABILITY
                <br />DEPLOYABLE SOLAR ARRAYS
                <br />
                FOR CUBESATS
                <br/> <br/> <strong>TRL 9</strong>
              </div>
            </div>
          <div className="col-span-2 md:col-span-1 flex justify-center md:justify-end z-40 my-16 mb-12">
            <div className="grid grid-cols-1 flex gap-8 sm:mt-0 text-white md:mr-20">
              {/* Lead time counter */}
              <Counter
                type="custom"
                start={0}
                end={8}
                unit="-10"
                customLabel="MONTHS"
                upperText="LEAD TIME"
              />
              {/* Sizes */}
              <div className="text-white text-center">
                <p className="text-xl uppercase text-white mb-4">
                  SIZES
                </p>
                <p className="text-3xl font-bold uppercase tracking-tight">
                  6U - 8U<br/>12U - 16U
                </p>
              </div>
              <h1 className="text-md uppercase pt-4 text-center mx-auto w-64 opacity-0">
                Lead times refer to standard version. Discounts for high-volume
                orders are possible.
              </h1>
            </div>
          </div>
        </div>

        {/* ── CTA BUTTONS ── */}
        <div
          className="flex flex-col sm:flex-row justify-center items-center gap-2 md:gap-12 py-12 font-bold"
          data-aos="fade-zoom-in"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600"
        >
          <a href="/pdf/PAVEL%20datasheet.pdf" download="PAVEL-datasheet.pdf">
          <button
            className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
            style={{
              background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
            }}
            onClick={() => {
              /* link to datasheet */
            }}
          >
            DOWNLOAD DATASHEET
          </button>
            </a>

          <button
            className="rounded-full w-auto h-12 text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
            style={{
              background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
            }}
            onClick={() => handleRequestClick()}
          >
            REQUEST QUOTATION
          </button>
        </div>

        {/*ANIMATED BLOCKS*/}
        <div className="  h-full flex flex-col  z-0 my-20">

          <div className=" grid grid-cols-1 md:grid-cols-3 gap-4 px-2 sm:mt-0 text-white">

            <PavelStat
                upper="FLEXIBLE PRINTED CIRCUIT"
                value="ELECTRICAL"
                label="CONNECTIONS REPLACING MANUAL WIRING"
            />
            <PavelStat
                upper="COMPATIBLE WITH DIFFERENT"
                value="TRIPLE JUNCTION"
                label="SOLAR CELL ASSEMBLY TYPES"
            />
            <PavelStat
                upper="FLIGHT"
                value="PROVEN"
                label="DEPLOYMENT SYSTEM"
            />

          </div>
        </div>
        <div id='main-features' className="h-20"></div>


        {/*{/* ── KEY FEATURES STRIP ── */}
        {/*
        <div
            className="h-full flex flex-col  bg-opacity-50 z-40 my-20 pt-24"
            data-aos="fade-zoom-in"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 sm:mt-0 text-white">

            <div className="flex flex-col items-center text-center px-6 py-4 ">
              <p className="text-xs uppercase tracking-widest text-white/50 mb-2">
                FLEXIBLE PRINTED CIRCUIT
              </p>
              <p className="text-2xl md:text-3xl font-bold uppercase tracking-tight">
                ELECTRICAL
              </p>
              <p className="text-xs uppercase text-white/60 mt-2">
                CONNECTIONS REPLACING WIRING
              </p>
            </div>

            <div className="flex flex-col items-center text-center px-6 py-4 ">
              <p className="text-xs uppercase tracking-widest text-white/50 mb-2">
                COMPATIBLE WITH DIFFERENT
              </p>
              <p className="text-2xl md:text-3xl font-bold uppercase tracking-tight">
                SOLAR CELL
              </p>
              <p className="text-xs uppercase text-white/60 mt-2">
                TYPES (TRIPLE JUNCTION / SILICON)
              </p>
            </div>

            <div className="flex flex-col items-center text-center px-6 py-4 ">
              <p className="text-xs uppercase tracking-widest text-white/50 mb-2">
                FLIGHT
              </p>
              <p className="text-2xl md:text-3xl font-bold uppercase tracking-tight">
                PROVEN
              </p>
              <p className="text-xs uppercase text-white/60 mt-2">
                DEPLOYMENT SYSTEM
              </p>
            </div>
          </div>
        </div> */}

        {/* ── PRODUCT IMAGES ── */}
        <div
            className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-[1600px] mx-auto px-4 md:px-16 mb-20"
            data-aos="fade-zoom-in"
            data-aos-offset="200"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
        >
          <div className="flex flex-col">
            <div className="aspect-[16/10] w-full overflow-hidden bg-black">
              <img
                  src="/products/Pavel/U-Space_12U%205.png"
                  alt="PAVEL solar array panel 1"
                  className="w-full h-full object-contain opacity-80"
              />
            </div>
          </div>

          <div className="flex flex-col">
            <div className="aspect-[16/10] w-full overflow-hidden bg-black">
              <img
                  src="/products/Pavel/U-Space_12U%206.png"
                  alt="PAVEL solar array panel 2"
                  className="w-full h-full object-contain opacity-80"
              />
            </div>
            <p className="mt-2 text-[11px] md:text-xs uppercase tracking-wide text-white text-right">
              Credits: C3S
            </p>
          </div>
        </div>

        {/* ── CUSTOMIZE PAVEL ── */}
        <div className="px-4 md:px-10 mb-20">
          <CustomizePavel placeholderImage="/products/Pavel/Rectangle 16.png" />
        </div>

        {/* ── USE CASES ── */}
        <div id="main-features" className="h-20"></div>
        <div className="relative text-white grid grid-cols-3 h-full w-full max-w-[1600px] mx-auto sm:px-10 pt-6 font-bold">
          <h1
            data-aos="fade-zoom-in"
            data-aos-offset="100px"
            data-aos-delay="0"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            className="my-12 col-span-3 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white "
          >
            USE CASES
          </h1>

          <div className="mt-[4rem] flex flex-col items-center col-span-3 md:col-span-1 ">

            <div className="uppercase text-center">
              <div className="text-xl">
                HIGH-STABILITY
                <br />
                EARTH OBSERVATION
                <br />
                MISSIONS
              </div>
            </div>
          </div>

          <div className="mt-[4rem] flex flex-col items-center col-span-3 md:col-span-1">

            <div className="uppercase text-center">
              <div className="text-xl">
                HIGH-POWER,
                <br />
                HIGH DUTY CYCLE
                <br />
                RF / IOT MISSIONS
              </div>
            </div>
          </div>

          <div className="mt-[4rem] flex flex-col items-center col-span-3 md:col-span-1 mb-32">

            <div className="uppercase text-center">
              <div className="text-xl">
                LOW-JITTER
                <br />
                REQUIREMENT
                <br />
                SCIENCE MISSIONS
              </div>
            </div>
          </div>
        </div>

        {/* QUALIFICATION Section */}
        <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mt-4 mb-40" >
          {/* Your content here */}
          <h1
              data-aos="fade-zoom-in"
              data-aos-offset="300px"
              data-aos-delay="0"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
              className=" my-12 text-4xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white ">
            QUALIFICATION{" "}
          </h1>

          <div>
            <div className="grid text-center mt-4 md:grid-cols-3 gap-4 w-full max-w-[1600px] mx-auto px-4 sm:grid-cols-1 gap-y-20 align-top " data-aos="zoom-out-in"
                 data-aos-offset="200"
                 data-aos-easing="ease-in-sine"
                 data-aos-duration="600">
              <div className="value-item "
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="400"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                    text="mechanical"
                    imageSrc="/products/product_q_mechanical.svg"
                    description={"STATIC LOADS, RANDOM AND\n" +
                "SINE VIBRATIONS TESTING\n" +
                " ACCORDING TO NASA GEVS"}
                    textAlign="center"

                />
              </div>
              <div className="value-item"
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="800"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                    text="THERMAL VACUUM"
                    imageSrc="/products/product_q_thermal.svg"
                    description={"8 CYCLES IN OPERATIONAL\n" +
                        "TEMPERATURE RANGE, WITH\n" +
                        "DEPLOYMENT IN COLD CASE"
                    } textAlign="center"
                />
              </div>
              <div className="value-item"
                   data-aos="fade-zoom-in"
                   data-aos-offset="300px"
                   data-aos-delay="1200"
                   data-aos-easing="ease-in-sine"
                   data-aos-duration="600">
                <ImageTextWithStatus
                    text="PVA thermal fatigue"
                    imageSrc="/products/product-q-pva.svg"
                    description={"Accelerated thermal\n" +
                        "cycling to validate \n" +
                        "PVA processes"}
                    textAlign="center"
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── TECHNICAL SPECIFICATIONS ── */}
        <div id="tech-specs" className="h-10"></div>
        <div className="h-full flex flex-col bg-black bg-opacity-50 z-40 mb-40">
          <h1
            data-aos="fade-zoom-in"
            data-aos-offset="300px"
            data-aos-delay="0"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            className="my-12 text-3xl md:text-5xl leading-120 tracking-tighter text-center uppercase font-bold text-white"
          >
            TECHNICAL SPECIFICATIONS
          </h1>

          <div className="grid gap-4 grid-cols-1 w-full max-w-[820px] mx-auto px-4 md:px-8">
            <div
                data-aos="fade-zoom-in"
                data-aos-offset="300px"
                data-aos-delay="400"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
            >
              <TechSpecs
                  title=""
                  description={[
                    { title: "LIFETIME: ", description: "5 YEARS" },
                    {
                      title: "OPERATING TEMPERATURE RANGE: ",
                      description: "-100°C / +90°C",
                    },
                    {
                      title: "NON-OPERATING TEMPERATURE RANGE: ",
                      description: "-110°C / +100°C",
                    },
                    { title: "TARGET ENVIRONMENT: ", description: "LEO" },
                  ]}
              />
            </div>
          </div>

          {/* Power table */}
          <div className="mt-10 w-full max-w-[1100px] mx-auto px-4 md:px-8">
            <PavelPowerTable />
          </div>
        </div>

          {/*VIDEO Section */}
          <div className="w-full my-40">
            <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
              <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://player.vimeo.com/video/1202511294?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  title="Pavel 4 HQ"
              />
            </div>
          </div>

        {/* ── CONTACT US ── */}
        <Link to="/contact">
          <div className="flex items-center justify-center pb-16">
            <button
                className="rounded-full w-auto h-12 text-center text-white px-8 font-bold transform transition-transform duration-200 hover:scale-110"
              style={{
                background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
              }}
            >
              CONTACT US
            </button>
          </div>
        </Link>
      </div>

      {isPopupOpen && (
        <OverlayForm
          formUrl="https://webforms.pipedrive.com/f/6UR9Re8nR5VKrsxbJHNTBDLcsXv6xjIStMZYDU4iiOvEJdEo7cZwg4M1uAm9NAG7WX"
          onClose={handleClosePopup}
        />
      )}
    </div>
  );
}
